import component from './AffiliateSettings.vue'
export default component
